import React, { useState, useEffect } from 'react';
import { Link, useParams ,useNavigate} from 'react-router-dom';
import Select from 'react-select';
import MainPagetitle from '../../layouts/MainPagetitle';
import { Modal, Button } from 'react-bootstrap';
import PriceService from '../../api/services/PriceService';
import CamperService from '../../api/services/CamperService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const EditPrice = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [error, setError] = useState("")
  const [priceModal, setPriceModal] = useState(false);
  const [pricing, setpricing] = useState([]);
  const [isLoading, setisloading] = useState(true);
  const [camper, setCamper] = useState([]);
  const [is_camper, setIs_camper] = useState([]);
  useEffect(() => {
    if (localStorage.getItem("admintoken")) {
    var id = params.id;
    
    getPriceByID(id);
  }
  else {
      navigate('/')
  }
  }, []);

  const getPriceByID = async (id) => {
    try {
      let pricing = await PriceService.show(id).json();
      let camper = await CamperService.index().json();
      
      setpricing(pricing.data);
      
      var responsedata = camper.data.filter(function (item) {
        return item.camper_type_id == 1
      });
      
      setCamper(responsedata);
      let selectcamper = camper.data.filter(function (item) {
        return item.id === pricing.data.camper_id;
      });
      setIs_camper(selectcamper)
      setisloading(false);

    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };

  const handleCamper = ishome => {
    setIs_camper(ishome || [])

  }
  const onSubmit = async (event) => {
    event.preventDefault();
    setError("")

    try {
      var userData = {

        "title": event.target.title.value,
        "start_date": event.target.start_date.value,
        "end_date": event.target.end_date.value,
        "percentage": event.target.percentage.value,
        "camper_id": is_camper.id ? is_camper.id : pricing.camper_id,
      }
      let responseData = await PriceService.update(params.id, userData).json()
      if (responseData.status === true) {
        setPriceModal(true)
      }
    } catch (errorJson) {

      if (errorJson.name === 'HTTPError') {
        if (errorJson.message) {
          setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
        }
        else {
          setError(errorJson.msg)
        }
      }
    }
  };

  return (
    <>
      <MainPagetitle mainTitle="Pricing" pageTitle={'Pricing'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Edit Pricing</h4>
              </div>
              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmit}>
                  <div className="row">

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username"
                        defaultValue={
                          pricing.title
                            ? pricing.title
                            : ''
                        } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >StartDate<span className="text-danger">*</span></label>
                      <input type="date" className="form-control" name='start_date' id="val-username"
                        defaultValue={
                          pricing.start_date
                            ? pricing.start_date.slice(0, 10)
                            : ''
                        } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >EndDate<span className="text-danger">*</span></label>
                      <input type="date" className="form-control" name='end_date' id="val-username"
                        defaultValue={
                          pricing.end_date
                            ? pricing.end_date.slice(0, 10)
                            : ''
                        } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Percentage<span className="text-danger">*</span></label>
                      <input type="number" className="form-control" name='percentage' id="val-username"
                        defaultValue={
                          pricing.percentage
                            ? pricing.percentage
                            : ''
                        } min={0} />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="exampleFormControlInput2" className="form-label"> Select Camper <span className="text-danger">*</span></label>

                      <Select
                        options={camper}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        getOptionValue={(option) => option.title}
                        getOptionLabel={(option) =>
                          option.title
                            ? option.title
                            : option.title
                        }
                        value={is_camper}
                        onChange={handleCamper}

                      />
                    </div>
                  </div>
                  <h5 style={{ color: 'red' }}>{error}</h5>
                  <div>
                    <button type="submit" className="btn btn-primary mb-2 me-1"  >Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <LogoAnimationLoader />}
      <Modal centered className="mark-attendence" show={priceModal}>
        <Modal.Header>
          <Modal.Title>Update </Modal.Title>
          <Button variant="" className="btn-close" onClick={() => setPriceModal(false)}></Button>
        </Modal.Header>
        <Modal.Body>Update Price Successfully!!!.</Modal.Body>
        <Modal.Footer>
          <Link className="btn btn-primary" to='/admin/pricing_management' variant="danger light" onClick={() => setPriceModal(false)}>Close</Link>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EditPrice;